import { Field } from "@app/shared/models/form-field.model";
import { AbstractAdapter } from "@app/shared/models/adapter.model";
import { CrudModes } from "@app/shared/components/abstracts/base-component";
import { LANGUAGES } from "@app/shared/constants/localization.constants";

export class TranslationsParms {
  constructor(
    public id: string,
    public data: TranslationsList,
    public mode: CrudModes,
    public description: string
  ) {}
}

/**
 * This model is to be used for maintaining applications, modules, groups, and menu-items.
 */
export interface Translations {
  id: string;
  translationList: TranslationsList[];
}

export interface TranslationsList {
  language: string;
  description: string;
  isSelected: boolean;

  _language: string;
}

export interface Translation {
  id: string;
  language: Field;
  titleDescription: Field;
  longTitleDescription: Field;
}

/**
 * Class: TranslationsAdapter
 *
 * Implements a data adapter for translations.
 */
export class TranslationsAdapter extends AbstractAdapter<Translations> {
  adapt(rawData: any): Translations {
    (rawData.translationList as TranslationsList[]).map((e) => {
      e._language =
        e.language === LANGUAGES.ENGLISH.value ? this.translate("APP.LBL_ENGLISH") : this.translate("APP.LBL_SPANISH");
      e.isSelected = false;
      return e;
    });
    return rawData;
  }
}

/**
 * Class: TranslationAdapter
 *
 * Implements a data adapter for a translation.
 */
export class TranslationAdapter extends AbstractAdapter<Translation> {
  adapt(rawData: any): Translation {
    return rawData;
  }
}
